import {
  SurveyBlockWithQuestionType,
  SurveyQuestionType,
  SurveyResponseType,
  SurveyType,
} from '../../../../../shared/types';

export const getBlocks = ({ surveyInfo = {} }: { surveyInfo?: SurveyType }) => {
  const { question_details, blocks } = surveyInfo;
  const surveyQuestions = question_details?.questions || [];
  const newBlocks =
    (blocks || [])
      ?.map((block: any) => {
        if (block.question_name) {
          const q = surveyQuestions.find(
            (q: SurveyQuestionType) => q.name === block.question_name,
          );
          return { ...block, question_type: q?.type_info?.question_type };
        } else {
          const q = surveyQuestions.find(
            (q: SurveyQuestionType) =>
              q.name === block.category[0].question_name,
          );
          return { ...block, question_type: q?.type_info?.question_type };
        }
      })
      .filter((b: any) => b.name !== 'TY') || [];
  return newBlocks;
};

export const loadBlockQuestion = ({
  block,
  surveyInfo,
  ratingType,
  surveyResponse,
  placeholders,
}: {
  block: SurveyBlockWithQuestionType;
  surveyResponse: SurveyResponseType;
  ratingType: any;
  surveyInfo: SurveyType;
  placeholders: any;
}) => {
  const question_answers: any = surveyResponse.detailed_data;
  const { category } = block;

  const pivotQuestion = surveyInfo?.question_details?.questions?.find(
    (q: any) => {
      return q.type_info.pivot_question;
    },
  );
  const range = pivotQuestion?.type_info?.scale_properties?.range;
  const range_id = range?.find((r: any) => r.label === ratingType)?.id;

  const question_name = category?.find((c) => c.id == range_id)?.question_name;

  const blockquestion: any = category ? question_name : block.question_name;
  const questionTitle =
    surveyResponse.detailed_data?.find((q: any) => q.name === blockquestion)
      ?.question || '';
  const labels =
    surveyResponse.detailed_data?.find((q: any) => q.name === blockquestion)
      ?.labels || '';
  const question = surveyInfo.question_details?.questions?.find((q) => {
    return q.name === blockquestion;
  });
  const answer =
    question?.type_info?.question_type === 'MESSAGE'
      ? question_answers.find((a) => {
          return a.name === blockquestion;
        })?.labels?.[0]
      : question_answers.find((a) => {
          return a.name === blockquestion;
        })?.answer;

  if (blockquestion)
    return {
      block: block,
      question: question,
      labels: labels,
      deleted_on: block.deleted_on,
      is_deleted: block.is_deleted,
      name: blockquestion,
      questionTitle: sanitizeQuestion({
        question: questionTitle,
        surveyResponse,
        surveyInfo,
        placeholders,
      }),
      answer:
        typeof answer === 'boolean'
          ? Boolean(answer)
          : answer || (answer === 0 ? answer : '-'),
    };
};

const sanitizeQuestion = ({
  placeholders,
  question,
  surveyInfo,
  surveyResponse,
}: {
  question: string;
  surveyResponse: SurveyResponseType;
  surveyInfo: any;
  placeholders: any;
}) => {
  if (question) {
    const allPlaceholders: any = {
      [`{{${surveyInfo?.type?.toLowerCase()}_rating}}`]:
        surveyResponse?.[`${surveyInfo?.type?.toLowerCase()}_rating`],
      ...placeholders,
    };
    const pattern = new RegExp(Object.keys(allPlaceholders).join('|'), 'gi');

    question = question.replace(
      pattern,
      (matched) => allPlaceholders[matched.toLowerCase()],
    );
  }
  return question;
};
